import { Injectable } from '@angular/core';
import { IMqttMessage, MqttService } from "ngx-mqtt";
import { Observable } from "rxjs";

@Injectable()
export class EventMqttService {

  private endpoint: string;
  private table: string;
  

  constructor(
    private _mqttService: MqttService,
  ) {
    this.endpoint = 'Server';
    this.table = 'TagDataTable';
  }

  topic(deviceId: string): Observable<IMqttMessage> {
    let topicName = `/${this.endpoint}/${deviceId}/${this.table}`;     
    return this._mqttService.observe(topicName);
  }
}